var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLedMagnifier(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 20.25a8.946 8.946 0 005.51-1.899l4.945 4.946 1.59-1.591-4.945-4.946a8.946 8.946 0 001.9-5.51c0-4.962-4.038-9-9-9s-9 4.038-9 9 4.038 9 9 9zm0-15.75A6.757 6.757 0 0118 11.25 6.757 6.757 0 0111.25 18a6.757 6.757 0 01-6.75-6.75 6.757 6.757 0 016.75-6.75z",
    fill: "#8E8E8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.838 9.66c.426.427.662.992.662 1.59h2.25a4.474 4.474 0 00-1.321-3.181c-1.703-1.701-4.657-1.701-6.359 0L9.66 9.662c.855-.853 2.329-.85 3.18-.003z",
    fill: "#8E8E8E"
  })));
}
export default SvgLedMagnifier;